import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import CheckOkButton from '../atoms/CheckOkButton';
import CheckNgButton from '../atoms/CheckNgButton';
import CheckInvalidButton from '../atoms/CheckInvalidButton';

const styles = {
  textGroup: {
    whiteSpace: 'pre-wrap'
  },
  textBody: {
    fontWeight: 'normal',
    fontSize: 14
  },
  breakLine: {
    whiteSpace: 'break-spaces'
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  pure,
  connect(
    state => ({
      account: state.accounts.account
    }),
    () => ({})
  )
);

const ReleaseTableBody = enhance(
  ({
    shops,
    classes, // emptyRows,
    page,
    rowsPerPage,
    shopRedirectAction,
    menuRedirectAction,
    identityAction,
    shopUnRelationAction,
    order,
    orderBy,
    account
  }) => {
    const sortedResult = _.orderBy(shops, orderBy, order);
    const groupDisplayLimit = account.groupDisplayLimit === 1;
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            const isIdentityConfirmed = shop.accountStatus.identity;
            const isIdentityRegistered =
              !shop.accountStatus.identity &&
              shop.accountStatus.identityRegistered;
            const isIdentityRegister =
              !shop.accountStatus.identity &&
              !shop.accountStatus.identityRegistered &&
              shop.accountStatus.identityRegisterable;
            const isStripeRegister =
              !shop.accountStatus.identity &&
              !shop.accountStatus.identityRegistered &&
              !shop.accountStatus.identityRegisterable;

            const onClickParams = {
              shopId: shop.shopId,
              shopName: shop.shopName,
              stripeUseSwitchable: shop.stripeUseSwitchable
            };
            return (
              <TableRow key={shop.shopId}>
                <TableCell className={classes.textBody}>
                  {shop.shopId}
                </TableCell>
                <TableCell className={[classes.textBody, classes.breakLine]}>
                  {shop.shopName}
                </TableCell>
                <TableCell className={classes.textBody}>
                  {shop.accountStatus.shop && (
                    <CheckOkButton
                      id={shop.shopId}
                      disabled={groupDisplayLimit}
                      onClickAction={shopRedirectAction}
                    />
                  )}
                  {!shop.accountStatus.shop && (
                    <CheckNgButton
                      id={shop.shopId}
                      disabled={groupDisplayLimit}
                      onClickAction={shopRedirectAction}
                    />
                  )}
                </TableCell>
                <TableCell className={classes.textBody}>
                  {shop.accountStatus.menu && (
                    <CheckOkButton
                      id={shop.shopId}
                      disabled={groupDisplayLimit}
                      onClickAction={menuRedirectAction}
                    />
                  )}
                  {!shop.accountStatus.menu && (
                    <CheckNgButton
                      id={shop.shopId}
                      disabled={groupDisplayLimit}
                      onClickAction={menuRedirectAction}
                    />
                  )}
                </TableCell>
                <TableCell className={classes.textBody}>
                  {/* 本人確認登録済み＋確認済みの場合 */}
                  {isIdentityConfirmed && (
                    <CheckOkButton
                      disabled={groupDisplayLimit}
                      onClickAction={
                        identityAction.identityConfirmedAlertAction
                      }
                    />
                  )}
                  {/* 本人確認登録済み＋未確認の場合 */}
                  {isIdentityRegistered && (
                    <CheckNgButton
                      disabled={groupDisplayLimit}
                      onClickAction={
                        identityAction.identityRegisteredAlertAction
                      }
                    />
                  )}
                  {/* 本人確認未登録＋Stripe登録済み(もしくは入金管理がNONSELF)の場合 */}
                  {isIdentityRegister && (
                    <CheckNgButton
                      disabled={groupDisplayLimit}
                      id={shop.shopId}
                      onClickAction={identityAction.identiryRegisterOpenAction}
                    />
                  )}
                  {/* 本人確認未登録＋Stripe未登録の場合 */}
                  {isStripeRegister && (
                    <CheckNgButton
                      disabled={groupDisplayLimit}
                      id={shop.shopId}
                      onClickAction={identityAction.identiryRegisterOpenAction}
                    />
                  )}
                </TableCell>
                <TableCell className={classes.textBody}>
                  {shop.paymentGroupType === 'STRIPE' ? (
                    <>
                      {shop.paymentGroupAccount ? (
                        <>
                          <CheckOkButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <CheckNgButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {shop.depositManage === 'SELF' &&
                        shop.accountStatus.stripeAccount && <CheckOkButton />}
                      {shop.depositManage === 'SELF' &&
                        !shop.accountStatus.stripeAccount && <CheckNgButton />}
                      {shop.depositManage !== 'SELF' && <CheckInvalidButton />}
                    </>
                  )}
                </TableCell>
                <TableCell className={classes.textBody}>
                  {shop.paymentGroupType === 'BANK' ? (
                    <>
                      {shop.paymentGroupAccount ? (
                        <>
                          <CheckOkButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          <CheckNgButton />
                          {shop.paymentGroupName && (
                            <div className={classes.textGroup}>
                              {`(${shop.paymentGroupName})`}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {shop.depositManage === 'NONSELF' && <CheckOkButton />}
                      {shop.depositManage !== 'NONSELF' && (
                        <CheckInvalidButton />
                      )}
                    </>
                  )}
                </TableCell>
                <TableCell className={classes.textBody}>
                  <Button
                    className={classes.textBody}
                    color="secondary"
                    onClick={() => shopUnRelationAction(onClickParams)}
                  >
                    <LinkOffIcon className={classes.leftIcon} />
                    店舗紐付け解除
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        {/* {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )} */}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ReleaseTableBody);
